/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateMehrarbeitAuszahlungDto } from '../../models/create-mehrarbeit-auszahlung-dto';
import { MehrarbeitAuszahlungDto } from '../../models/mehrarbeit-auszahlung-dto';

export interface CreateMehrarbeitAuszahlung$Json$Params {
  
    /**
     * Daten der Mehrarbeit Auszahlung
     */
    body?: CreateMehrarbeitAuszahlungDto
}

export function createMehrarbeitAuszahlung$Json(http: HttpClient, rootUrl: string, params?: CreateMehrarbeitAuszahlung$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<MehrarbeitAuszahlungDto>> {
  const rb = new RequestBuilder(rootUrl, createMehrarbeitAuszahlung$Json.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MehrarbeitAuszahlungDto>;
    })
  );
}

createMehrarbeitAuszahlung$Json.PATH = '/v1/mehrarbeitauszahlung/create';
